import styled from '@emotion/styled';

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  height: 36px;
  padding: 8px;
  cursor: pointer;
  transition: color 0.3s linear;

  &:hover {
    background: #bbbfc72b;
    border-radius: 8px;
  }
`;

export const GroupTitle = styled.span`
  display: flex;
  align-items: center;
`;

export const Chevron = styled.span<{ open: boolean }>`
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s ease;
  transform: rotate(${({ open }) => (open ? '90deg' : '0deg')});
`;
